import { AuditReportsBroadcastEvidenceConfigDto, AuditReportsReportRun } from '@mi-front/api-v2';

/**
 * Narrows report-run config to the broadcast evidence shape.
 */
export function getBroadcastEvidenceConfig(
  report: AuditReportsReportRun,
): AuditReportsBroadcastEvidenceConfigDto {
  return report.config as AuditReportsBroadcastEvidenceConfigDto;
}

/**
 * Whether the primary package artifact has a storage URI ready for download.
 */
export function hasPackageArtifactReady(report: AuditReportsReportRun): boolean {
  const packageArtifact = report.artifacts?.find((artifact) => artifact.kind === 'package');
  return Boolean(packageArtifact?.storageUri);
}
